var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"12"}},[_c('flow-create-form-wizard',{attrs:{"new-flow":_vm.newFlow}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }